export default typeof window === 'undefined' ? global : window;
